import HomePageActionTypes from "./homePage.types"

// put the user and userObject into the store
export const updateToRoot = (user) => ({
  type: HomePageActionTypes.UPDATE_TO_ROOT,
  payload: user,
})

export const updateSimpleQualification = (qualifications) => ({
  type: HomePageActionTypes.UPDATE_SIMPLE_QUALIFICATION,
  payload: qualifications
})

// ---------------------------------------------------

// delete one item in resume page.
export const deleteQualification = (itemID) => ({
  type: HomePageActionTypes.DELETE_QUALIFICATION,
  payload: itemID,
})

export const deleteProfessionalDevelopment = (itemID) => ({
  type: HomePageActionTypes.DELETE_PROFESSIONAL_DEVELOPMENT,
  payload: itemID,
})

export const deleteProfessionalExperience = (itemID) => ({
  type: HomePageActionTypes.DELETE_PROFESSIONAL_EXPERIENCE,
  payload: itemID,
})

export const deleteRefereeCheck = (itemID) => ({
  type: HomePageActionTypes.DELETE_REFEREE_CHECK,
  payload: itemID,
})

export const deleteNonTeachingExperience = (itemID) => ({
  type: HomePageActionTypes.DELETE_NON_TEACHING_EXPERIENCE,
  payload: itemID,
})

export const deleteVetTrainingQualification = (itemID) => ({
  type: HomePageActionTypes.DELETE_VET_TRAINING_QUALIFICATION,
  payload: itemID,
})

export const deleteVetIndustryQualification = (itemID) => ({
  type: HomePageActionTypes.DELETE_VET_INDUSTRY_QUALIFICATION,
  payload: itemID,
})

export const deleteVetProfessionalDevelopment = (itemID) => ({
  type: HomePageActionTypes.DELETE_VET_PROFESSIONAL_DEVELOPMENT,
  payload: itemID,
})

export const deleteVetTrainingExperience = (itemID) => ({
  type: HomePageActionTypes.DELETE_VET_TRAINING_EXPERIENCE,
  payload: itemID,
})

export const deleteVetIndustryExperience = (itemID) => ({
  type: HomePageActionTypes.DELETE_VET_INDUSTRY_EXPERIENCE,
  payload: itemID,
})

export const deleteVetTrainerMatrix = (itemID) => ({
  type: HomePageActionTypes.DELETE_VET_TRAINER_MATRIX,
  payload: itemID,
})

// ---------------------------------------------------
// edit or add one item in resume page.

export const updateQualification = (item) => ({
  type: HomePageActionTypes.UPDATE_QUALIFICATION,
  payload: item,
})

export const updateProfessionalDevelopment = (item) => ({
  type: HomePageActionTypes.UPDATE_PROFESSIONAL_DEVELOPMENT,
  payload: item,
})

export const updateProfessionalExperience = (item) => ({
  type: HomePageActionTypes.UPDATE_PROFESSIONAL_EXPERIENCE,
  payload: item,
})

export const updateRefereeCheck = (item) => ({
  type: HomePageActionTypes.UPDATE_REFEREE_CHECK,
  payload: item,
})

export const updateNonTeachingExperience = (item) => ({
  type: HomePageActionTypes.UPDATE_NON_TEACHING_EXPERIENCE,
  payload: item,
})

// ---------------------------------------------------
// Add can deliver in the profile page

export const addCanDeliver = (user) => ({
  type: HomePageActionTypes.ADD_CAN_DELIVER,
  payload: user,
})

export const addCanDeliverAdmin = (user) => ({
  type: HomePageActionTypes.ADD_CAN_DELIVER_ADMIN,
  payload: user,
})

export const saveShareProfileTeacherID = (id) => ({
  type: HomePageActionTypes.SAVE_SHARE_PROFILE_TEACHER_ID,
  payload: id,
})

// ---------------------------------------------------

// update personal details
export const updatePersonalDetails = (detials) => ({
  type: HomePageActionTypes.UPDATE_PERSONAL_DETAILS,
  payload: detials,
})

// ---------------------------------------------------
// update availability
export const updateAvailability = (user) => ({
  type: HomePageActionTypes.UPDATE_AVAILABILITY,
  payload: user,
})

export const updateVetTrainingQualification = (item) => ({
  type: HomePageActionTypes.UPDATE_VET_TRAINING_QUALIFICATION,
  payload: item,
})

export const updateVetIndustryQualification = (item) => ({
  type: HomePageActionTypes.UPDATE_VET_INDUSTRY_QUALIFICATION,
  payload: item,
})

export const updateVetProfessionalDevelopment = (item) => ({
  type: HomePageActionTypes.UPDATE_VET_PROFESSIONAL_DEVELOPMENT,
  payload: item,
})

export const updateVetTrainingExperience = (item) => ({
  type: HomePageActionTypes.UPDATE_VET_TRAINING_EXPERIENCE,
  payload: item,
})

export const updateVetIndustryExperience = (item) => ({
  type: HomePageActionTypes.UPDATE_VET_INDUSTRY_EXPERIENCE,
  payload: item,
})

export const updateVetTrainerMatrix = (item) => ({
  type: HomePageActionTypes.UPDATE_VET_TRAINER_MATRIX,
  payload: item,
})

// ---------------------------------------
// job board

export const applyToListing = (listing_id, inst, publisher_id) => ({
  type: HomePageActionTypes.APPLY_TO_LISTING,
  payload: { listing_id, inst, publisher_id }
})

export const addFavouriteListing = (listing_id) => ({
  type: HomePageActionTypes.ADD_FAVOURITE_LISTING,
  payload: listing_id
})

export const removeFavouriteListing = (listing_id) => ({
  type: HomePageActionTypes.REMOVE_FAVOURITE_LISTING,
  payload: listing_id
})